module.exports = __webpack_public_path__ + "static/media/flame.56be189b.png";